import React, { useEffect, useState, useRef } from 'react';
import { ActivityRing, clickStreamUser, rings, scheduleSessionApiCall, SessionKeys } from '../../../utils/AppUtils';
import { useDispatch, useSelector } from 'react-redux';
import _, { set } from 'lodash';
import moment from 'moment';
import { getActivityRing, getActivityRingClear } from '../../../redux/courses/actions';
import ActivityLog from '../modal_finwell/ActivityLogModal';
import ActivityLogModal from '../modal_finwell/ActivityLogModal';
import ApexCharts from "apexcharts";
import { Spinner } from 'react-bootstrap';
import SessionRequest from './SessionRequest';
const ActivityRingComp = () => {
  const dispatch = useDispatch();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const activityRingRes = useSelector((state) => state.courses.activityRingRes);

  const [coachUrl, setCoachUrl] = useState("");
  const [activityRing, setActivityRing] = useState([]);
  const [ringsData, setRingsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  let chart = null;
  useEffect(() => {

    const month_start_date = moment().startOf('month').format('YYYY-MM-DD');
    const month_end_date = moment().endOf('month').format('YYYY-MM-DD');
    let req = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          month_start_date: month_start_date,
          month_end_date: month_end_date
        };
    clickStreamUser("ActivityRingComp", req, authBroker);
    setLoading(true);
    dispatch(
      getActivityRing({
        module: "getActivityRings",
        postData: req,
      })
    );
  }, []);

  useEffect(() => {
    console.log("userDetailResLocal", activityRingRes);
    if (!_.isEmpty(activityRingRes)) {
      setLoading(false);
      if (activityRingRes?.status === "success") {
        let data = activityRingRes?.payload?.payload;
        let ringsTemp = _.cloneDeep(rings);
        ringsTemp[0].value = data.learn_ring || 0;
        ringsTemp[1].value = data.plan_ring || 0;
        ringsTemp[2].value = data.act_ring || 0;
        let ringValues = [data.learn_ring || 0, data.plan_ring || 0, data.act_ring || 0];
        setActivityRing(ringValues);
        setRingsData(data);

        dispatch(getActivityRingClear());
      }
    }
  }, [activityRingRes]);

    const chartRef = useRef(null); // To store chart instance
   useEffect(() => {

    if (chartRef.current) {
      chartRef.current.destroy(); // Properly destroy previous chart
    }
   
    if (!activityRing || activityRing.length === 0) {
      return;
    }
    const customLabels = ['Earn your Learn ring by completing: articles, videos or courses.', 'Earn your Plan ring by completing: a session, checklist, or Money Metrics.', 'Earn your Act ring by completing: calculator, coaching, checklist, or Action Path'];
      var options = {
        series: activityRing,
        chart: {
          height: 108,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            track: {
              background: ['#D4EBE9', '#B3DCF9', '#DCB4FC'],  // <-- Trail color here
              margin: 1,
            },
            hollow: {
              margin: 1,
              size: '30%',
              background: 'transparent',
              image: undefined,
            },
            dataLabels: {
              show:false,
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: false,
                label: 'Total',
                formatter: function (w) {
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                  return 249
                }
              }
            }
          }
        },
        colors: ['#27897E', '#2684E8', '#B056F6'],
            stroke: {
        lineCap: 'round'  // <- Makes stroke ends rounded
      },
  labels: customLabels,
  tooltip: {
    enabled: true,
    fillSeriesColor: false, // Prevent colored background
    custom: function({ series, seriesIndex, w }) {
      const label = customLabels[seriesIndex];
      return `<div style="border:none;padding: 0.5rem; font-size: 1rem;background-color:rgb(17 17 17 / 72%);color:#ffffff;border-radius:0.25rem;">${label}</div>`;
    }
  }
      };

      chart = new ApexCharts(document.querySelector("#chart"), options);
      chart.render();
      chartRef.current = chart; // Save reference
 
    // Optional cleanup on unmount
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [activityRing]);


  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);

      }
    }
  }, [userDetailRes]);

  return (
    <>
      <section className="row mb-2rem mt-2rem" aria-label="Activity and coaching">
        <div id="activityRings" className="col-md-6">
          <div className="card-money" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content.">
            <div class="mb-1 align-items-center">
              <h3 className="card-money-title col-12 mb-0">Monthly activity rings</h3>
            </div>
            <p className="small-text-money mb-10">Every step gets you closer to financial wellness.</p>
            <div className="d-flex align-items-start gap-2">
              
              {loading ? <div className='d-flex align-items-center justify-content-center text-center' style={{
                position: "relative",
                width: "108px",
                height: "108px",
              }}><Spinner
                  as="span"
                  animation="border"
                  size="large"
                  role="status"
                  aria-hidden="true"
                /></div> : activityRing?.length > 0 ? <div
                  id='chart'
                  style={{
                    position: "relative",
                    width: "108px",
                    height: "108px",
                    minHeight: "108px"
                  }}
                >

                  {/* {false && activityRing.map((ring, index) => (
                  <ActivityRing key={index} {...ring} />
                ))} */}
                </div> : ""}
              <div className="action-list">
                <div className="action-item" aria-label='Learn'>
                  <span className="label">Learn</span>
                  <span className="count teal">{ringsData?.completed?.learn?.completed}/{ringsData?.completed?.learn?.total} actions</span>
                </div>
                <div className="action-item" aria-label='Plan'>
                  <span className="label">Plan</span>
                  <span className="count blue">{ringsData?.completed?.plan?.completed}/{ringsData?.completed?.plan?.total} actions</span>
                </div>
                <div className="action-item" aria-label='Act'>
                  <span className="label">Act</span>
                  <span className="count purple">{ringsData?.completed?.act?.completed}/{ringsData?.completed?.act?.total} actions</span>
                </div>
                <div className="rightlink d-flex align-items-start "><a onClick={() => setShow(true)} tabIndex={0} aria-label='View details' className="cursor-pointer">View details</a></div>
              </div>
            </div>
          </div>
        </div>
        <div id="coachingModule" className="col-md-6">
          <SessionRequest coach={coachUrl}/>
        </div>
      </section>
     {ringsData?.log? <ActivityLogModal show={show} setShow={setShow} ringData={ringsData?.log?ringsData?.log:{learn:[],act:[],plan:[]}} />:""}
    </>
  );
};

export default ActivityRingComp;